/* eslint-disable no-bitwise */
/* eslint-disable no-unused-vars */

const slider = () => {
  const sliders = document.querySelectorAll('.js-slider');
  sliders.forEach(container => {
    const pager = container.parentElement.querySelector('.js-slider-pager');
    pager.querySelectorAll('.js-slider-pager-item').forEach(page => {
      page.addEventListener('click', e => {
        container.parentElement
          .querySelectorAll('.js-slider-item, .js-slider-pager-item')
          .forEach(item => {
            item.classList.remove('is-active');
          });
        container
          .querySelectorAll('.js-slider-item')
          [[...pager.children].indexOf(e.target)].classList.add('is-active');
        e.target.classList.add('is-active');
      });
    });
  });
};

export default slider;



// WEBPACK FOOTER //
// ./wp/wp-content/themes/factory-logistic-chisel/src/scripts/modules/slider.js